import { useMemo } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import useGetCmsContent from 'pages/Cms/View/useGetCmsContent'
import { ZERO } from 'shared/constants'
import type { Block } from 'shared/graphql/graphql'
import type { CmsContentT } from 'types'
import { CONTENT_TYPES } from 'types/cms'

const useCmsContentViewPage = (contentUuid: string) => {
  const { content: cmsContent, loading } = useGetCmsContent({ contentUuid: contentUuid })
  const { blocks: contentBlocks, contentType } = (cmsContent as CmsContentT) ?? {}
  const { t } = useFavurTranslation()

  const title = useMemo(() => {
    const titleKey = (() => {
      switch (contentType) {
        case CONTENT_TYPES.page:
          return 'page.cms.content.detail.title'
        case CONTENT_TYPES.event:
          return 'page.cms.event.detail.title'
        case CONTENT_TYPES.newsletter:
          return 'page.cms.newsletter.detail.title'
        default:
          return 'page.cms.content.detail.title'
      }
    })()

    return t(titleKey)
  }, [contentType, t])

  const blocks = useMemo(
    () =>
      contentBlocks
        ? // eslint-disable-next-line -- disabled for mutating sort method
          [...contentBlocks]
            // This filter can be removed if we take the decision to manage the blocks returned by language in the BE
            // Removed filter for now as we currently only support one language and it doesn't need to be the same as the favur user one
            //.filter((block) => block.language === language)
            .sort((a, b): number => ((a as Block).order ?? ZERO) - ((b as Block).order ?? ZERO))
        : [],
    [contentBlocks],
  )

  return { t, content: cmsContent as CmsContentT, loading, title, blocks }
}

export default useCmsContentViewPage
